<template>
  <div class="pe-workspace-page">
    <van-nav-bar title="体育教学与测试工作台" fixed placeholder />

    <div class="module-section">
      <div class="section-title">测试与练习模块</div>
      <van-grid :column-num="4" clickable>
        <van-grid-item icon="play-circle-o" text="快速测试" @click="openModule('快速测试')" />
        <van-grid-item icon="clock-o" text="随堂测试" @click="openModule('随堂测试')" />
        <van-grid-item icon="flag-o" text="国家体测" @click="openModule('国家体测')" />
        <van-grid-item icon="smile-o" text="自由练习" @click="openModule('自由练习')" />
      </van-grid>
    </div>

    <van-tabs v-model="activeTab" color="#1989fa" sticky offset-top="46px">
      
      <van-tab title="教学与动作指导">
        <div class="guidance-list">
          <div class="notice-bar">
            <van-icon name="video-o" />
            <span>AI动作捕捉异常，以下学生需要一对一纠正指导。</span>
          </div>

          <div class="student-card" v-for="stu in guidanceList" :key="stu.id">
            <div class="card-head">
              <strong>{{ stu.name }}</strong> ({{ stu.className }})
              <van-tag :type="stu.status === '待指导' ? 'danger' : 'success'">{{ stu.status }}</van-tag>
            </div>
            <div class="card-body">
              <p class="issue-text"><strong>问题项目：</strong>{{ stu.project }}</p>
              <p class="issue-text"><strong>AI动作分析：</strong>{{ stu.aiAnalysis }}</p>
            </div>
            <div class="card-footer" v-if="stu.status === '待指导'">
              <van-button size="small" type="primary" round plain @click="markAsGuided(stu.id)">标记为已指导</van-button>
            </div>
          </div>
        </div>
      </van-tab>

      <van-tab title="运动项目管理">
        <div class="project-manager">
          <div class="toolbar">
            <span class="count">共 {{ projectList.length }} 个受管项目</span>
            <van-button size="small" type="info" icon="plus" @click="showAddPopup = true">新增项目</van-button>
          </div>

          <van-cell-group inset class="project-list">
            <van-swipe-cell v-for="proj in projectList" :key="proj.id">
              <van-cell :title="proj.name" :label="`项目编号: ${proj.code} | 类型: ${proj.type}`">
                <template #right-icon>
                  <van-tag type="primary" plain>{{ proj.mode }}</van-tag>
                </template>
              </van-cell>
              <template #right>
                <van-button square type="danger" text="删除" class="delete-btn" @click="deleteProject(proj.id)" />
              </template>
            </van-swipe-cell>
          </van-cell-group>
        </div>
      </van-tab>

    </van-tabs>

    <van-dialog v-model="showAddPopup" title="添加新运动项目" show-cancel-button @confirm="saveNewProject">
      <van-field v-model="newProject.name" label="项目名称" placeholder="如：50米跑" />
      <van-field v-model="newProject.code" label="项目编号" placeholder="如：Run50m" />
      <div style="padding: 10px 16px; font-size:14px; display:flex;">
        <span style="color:#646566; width:70px;">测试类型</span>
        <van-radio-group v-model="newProject.type" direction="horizontal">
          <van-radio name="田径类">田径</van-radio>
          <van-radio name="力量类">力量</van-radio>
          <van-radio name="球类">球类</van-radio>
        </van-radio-group>
      </div>
    </van-dialog>

  </div>
</template>

<script>
export default {
  name: 'PETeacherWorkspace',
  data() {
    return {
      activeTab: 0,
      
      // AI 动作指导数据
      guidanceList: [
        { id: 1, name: '李强', className: '初一(2)班', project: '立定跳远', aiAnalysis: '起跳时手臂未充分摆动，下肢爆发力未能有效传导。', status: '待指导' },
        { id: 2, name: '王芳', className: '初二(1)班', project: '仰卧起坐', aiAnalysis: '发力点偏移，过度使用颈部力量，易造成拉伤。', status: '待指导' },
        { id: 3, name: '陈伟', className: '初三(4)班', project: '1000米跑', aiAnalysis: '步幅过大，心率飙升过快，建议调整呼吸节奏。', status: '已指导' },
      ],

      // 全局项目管理数据
      projectList: [
        { id: 101, name: '800米跑', code: 'Run800m', type: '田径类', mode: '国家标准' },
        { id: 102, name: '立定跳远', code: 'Jump', type: '力量类', mode: 'AI抓拍' },
        { id: 103, name: '引体向上', code: 'PullUp', type: '力量类', mode: '红外传感' },
      ],
      
      // 新增项目表单
      showAddPopup: false,
      newProject: { name: '', code: '', type: '田径类' }
    };
  },
  methods: {
    // 宫格模块跳转提示
    openModule(moduleName) {
      this.$toast.success(`正在为您初始化 [${moduleName}] 模块...`);
    },

    // ======== 教学指导联动 ========
    markAsGuided(id) {
      const target = this.guidanceList.find(s => s.id === id);
      if (target) {
        target.status = '已指导';
        this.$toast.success('已完成动作纠正与一对一指导');
      }
    },

    // ======== 项目管理联动 (CRUD) ========
    saveNewProject() {
      if (!this.newProject.name) return this.$toast('请填写项目名称');
      
      // 将新数据插入项目列表
      this.projectList.push({
        id: Date.now(),
        name: this.newProject.name,
        code: this.newProject.code || 'CustomProj',
        type: this.newProject.type,
        mode: '自定义项目'
      });
      
      this.$toast.success('新测试项目接入成功');
      this.newProject = { name: '', code: '', type: '田径类' }; // 重置表单
    },
    
    deleteProject(id) {
      this.$dialog.confirm({ title: '确认删除', message: '删除后，无法再使用此项目发起测验。' })
        .then(() => {
          // 从数组中剔除
          this.projectList = this.projectList.filter(p => p.id !== id);
          this.$toast('项目已下线');
        }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.pe-workspace-page {
  background-color: #f7f8fa;
  min-height: 100vh;
  padding-bottom: 24px;
}

/* 四大核心模块区 */
.module-section {
  background: #fff;
  margin-bottom: 12px;
}
.section-title {
  padding: 14px 16px 0;
  font-size: 14px;
  font-weight: bold;
  color: #323233;
}

/* 一对一指导卡片 */
.guidance-list {
  padding: 12px;
}
.notice-bar {
  background-color: #e8f3fe;
  color: #1989fa;
  padding: 8px 12px;
  border-radius: 6px;
  font-size: 13px;
  display: flex;
  align-items: center;
  margin-bottom: 12px;
}
.notice-bar span { margin-left: 6px; }

.student-card {
  background: #fff;
  border-radius: 8px;
  padding: 14px;
  margin-bottom: 12px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.03);
}
.card-head {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 15px;
  padding-bottom: 8px;
  border-bottom: 1px solid #f2f3f5;
}
.issue-text {
  font-size: 13px;
  color: #646566;
  margin: 8px 0 0 0;
  line-height: 1.5;
}
.card-footer {
  text-align: right;
  margin-top: 10px;
}

/* 项目管理区 */
.project-manager {
  padding-top: 12px;
}
.toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 16px 12px;
}
.toolbar .count {
  font-size: 13px;
  color: #969799;
}
.delete-btn {
  height: 100%;
}
.project-list {
  margin-bottom: 20px;
}
</style>